import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles/index';

import { removeDialog } from 'data/rootUi/actions';

export const styles = () => ({
  textField: {
    marginTop: '10px',
    width: '60%',
  },
});

class FormDialog extends React.Component {

  state = {
    value: '',
  };

  onKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.stopPropagation();
      e.preventDefault();
      this.handleClose(this.props.buttons[this.props.buttons.length - 1]);
    }
  };

  handleClose = (btn) => {
    this.props.removeDialog(this.props.dialogId);
    if (this.props.onClose) {
      this.props.onClose({ btnPressed: btn, text: this.state.value });
    }
  };

  handleChange = (e) => {
    this.setState({ value: e.target.value });
  };

  renderButtons = () => {

    const btns = [];
    this.props.buttons?.forEach((btn) => btns.push(
      <Button id={`formdlg:${btn}`} key={`formdlg:${btn}`} onClick={() => this.handleClose(btn)} color="primary">
        {btn}
      </Button>
    ));
    return btns;
  };

  render() {

    const textFieldType = this.props.password ? 'password' : 'text';

    return (
      <Dialog
        open
        onClose={this.handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {this.props.content}
          </DialogContentText>
          <TextField
            className={this.props.classes.textField}
            autoFocus
            margin="dense"
            id="name"
            label={this.props.label}
            fullWidth
            value={this.state.value}
            onChange={this.handleChange}
            type={textFieldType}
            InputProps={{ onKeyDown: this.onKeyDown }}
          />
        </DialogContent>
        <DialogActions>
          {this.renderButtons()}
        </DialogActions>
      </Dialog>
    );
  }
}

FormDialog.propTypes = {
  dialogId: PropTypes.string,

  onClose: PropTypes.func,
  buttons: PropTypes.array,
  content: PropTypes.string,
  title: PropTypes.string,
  label: PropTypes.string,
  password: PropTypes.bool,

  classes: PropTypes.object,
  removeDialog: PropTypes.func,
};

function mapDispatchToProps(dispatch) {
  return {
    removeDialog: (props) => dispatch(removeDialog(props)),
  };
}

export default compose(
  withStyles(styles, { name: 'FormDialog' }),
  connect(null, mapDispatchToProps),
)(FormDialog);


